import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResponseApi, ResponseListApi } from '@core/models/interfaces/common';
import { CreatePartnerApps, PartnerAppDetails } from '@core/models/interfaces/facebook/partner-apps';
import { environment } from 'src/environments/environment';
import { HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class FacebookPartnerAppService {
  readonly baseURL: string = `${environment.API_URL}/crm/facebook/partner-apps`;

  constructor(private httpClient: HttpClient) {}

  createPartnerApp(body: { name: string; pageId: string; pageName: string }) {
    return this.httpClient.post<ResponseApi<CreatePartnerApps>>(`${this.baseURL}`, body);
  }

  getPartnerApp(params: { keyword?: string; pageId: string; page?: number; size?: number }) {
    let httpParams = new HttpParams();

    if (params.keyword) {
      httpParams = httpParams.set('keyword', params.keyword);
    }
    if (params.pageId) {
      httpParams = httpParams.set('pageId', params.pageId);
    }

    httpParams = httpParams.set('page', params?.page || 0);

    if (params.size) {
      httpParams = httpParams.set('size', params.size);
    }

    return this.httpClient.get<ResponseListApi<PartnerAppDetails>>(`${this.baseURL}/page`, {
      params: httpParams
    });
  }

  deletePartnerApp(id: string) {
    return this.httpClient.delete(`${this.baseURL}/${id}`);
  }
}
